/*= ========================================================================================
  File Name: moduleAuthMutations.js
  Description: Auth Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== */

export default {
  GET_LIST_PRIORITY(state, payload) {
      state.priority = JSON.stringify(payload);
      localStorage.setItem("listPriority", JSON.stringify(payload));
  },
  GET_LIST_VISIT_TYPE(state, payload) {
      state.visitType = JSON.stringify(payload);
      localStorage.setItem("listVisitType", JSON.stringify(payload));
  },
  GET_LIST_INSURER(state, payload) {
      state.insurer = JSON.stringify(payload);
      localStorage.setItem("listInsurer", JSON.stringify(payload));
  },
  GET_LIST_WARD(state, payload) {
      state.ward = JSON.stringify(payload);
      localStorage.setItem("listWard", JSON.stringify(payload));
  },
  GET_LIST_PHYSICIANS(state, payload) {
      state.ward = JSON.stringify(payload);
      localStorage.setItem("listPhysicians", JSON.stringify(payload));
  },
  GET_LIST_AVAILABLE_TEST_PCR(state, payload) {
      state.availableTestPCR = JSON.stringify(payload);
      localStorage.setItem("listAvailableTestPCR", JSON.stringify(payload));
  },
  GET_LIST_AVAILABLE_TEST_CLINIC(state, payload) {
      state.availableTestClinic = JSON.stringify(payload);
      localStorage.setItem("listAvailableTestClinic", JSON.stringify(payload));
  },
};
